/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { KioskMaintenanceDto } from '../models/kiosk-maintenance-dto';
import { maintenanceCheckInsurerMaintenance } from '../fn/maintenance/maintenance-check-insurer-maintenance';
import { MaintenanceCheckInsurerMaintenance$Params } from '../fn/maintenance/maintenance-check-insurer-maintenance';
import { maintenanceCheckKioskMaintenance } from '../fn/maintenance/maintenance-check-kiosk-maintenance';
import { MaintenanceCheckKioskMaintenance$Params } from '../fn/maintenance/maintenance-check-kiosk-maintenance';

@Injectable({ providedIn: 'root' })
export class MaintenanceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `maintenanceCheckKioskMaintenance()` */
  static readonly MaintenanceCheckKioskMaintenancePath = '/v1/Maintenance/CheckKioskMaintenance';

  /**
   * Permissions [LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME].
   *
   * <br />ACTION_CODE_POLICY: LIGHT_LOGIN_USER
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `maintenanceCheckKioskMaintenance()` instead.
   *
   * This method doesn't expect any request body.
   */
  maintenanceCheckKioskMaintenance$Response(params?: MaintenanceCheckKioskMaintenance$Params, context?: HttpContext): Observable<StrictHttpResponse<KioskMaintenanceDto>> {
    return maintenanceCheckKioskMaintenance(this.http, this.rootUrl, params, context);
  }

  /**
   * Permissions [LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME].
   *
   * <br />ACTION_CODE_POLICY: LIGHT_LOGIN_USER
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `maintenanceCheckKioskMaintenance$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  maintenanceCheckKioskMaintenance(params?: MaintenanceCheckKioskMaintenance$Params, context?: HttpContext): Observable<KioskMaintenanceDto> {
    return this.maintenanceCheckKioskMaintenance$Response(params, context).pipe(
      map((r: StrictHttpResponse<KioskMaintenanceDto>): KioskMaintenanceDto => r.body)
    );
  }

  /** Path part for operation `maintenanceCheckInsurerMaintenance()` */
  static readonly MaintenanceCheckInsurerMaintenancePath = '/v1/Maintenance/CheckInsurerMaintenance';

  /**
   * Permissions [LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME].
   *
   * <br />ACTION_CODE_POLICY: LIGHT_LOGIN_USER
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `maintenanceCheckInsurerMaintenance()` instead.
   *
   * This method doesn't expect any request body.
   */
  maintenanceCheckInsurerMaintenance$Response(params?: MaintenanceCheckInsurerMaintenance$Params, context?: HttpContext): Observable<StrictHttpResponse<KioskMaintenanceDto>> {
    return maintenanceCheckInsurerMaintenance(this.http, this.rootUrl, params, context);
  }

  /**
   * Permissions [LIGHT_LOGIN_USER] ,   Restricted to [KIOSK_HOME].
   *
   * <br />ACTION_CODE_POLICY: LIGHT_LOGIN_USER
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `maintenanceCheckInsurerMaintenance$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  maintenanceCheckInsurerMaintenance(params?: MaintenanceCheckInsurerMaintenance$Params, context?: HttpContext): Observable<KioskMaintenanceDto> {
    return this.maintenanceCheckInsurerMaintenance$Response(params, context).pipe(
      map((r: StrictHttpResponse<KioskMaintenanceDto>): KioskMaintenanceDto => r.body)
    );
  }

}
